module.exports = __webpack_public_path__ + "img/PT34.494ee8b4.png";